import { create } from 'zustand';

/**
 * Payment Filter Store
 * Session-only state for property filter selection in payment screens
 * No persistence needed - resets on app restart
 */
interface PaymentFilterState {
    selectedPropertyIds: string[];
    setSelectedPropertyIds: (ids: string[]) => void;
    clearFilter: () => void;
}

export const usePaymentFilterStore = create<PaymentFilterState>((set) => ({
    selectedPropertyIds: [],
    setSelectedPropertyIds: (ids: string[]) => set({ selectedPropertyIds: ids }),
    clearFilter: () => set({ selectedPropertyIds: [] }),
}));

